<div class="row mb-3">
    <label class="col-12 col-sm-6 col-form-label text-sm-end text-start" for="{{ (binding$ | async)?.xmlId }}">{{
        (binding$ | async)?.label
    }}</label>
    <div class="col">
        <input
            type="text"
            class="form-control input-md"
            id="{{ (binding$ | async)?.xmlId }}"
            [formControl]="inputFieldControl"
        />
    </div>
</div>
